export function fireTrackingUrl(url: string): void {
  const useImageFallback = () => {
    if (typeof Image !== "undefined") {
      new Image().src = url;
    }
  };

  if (typeof fetch === "function") {
    try {
      void fetch(url, {
        method: "GET",
        keepalive: true,
        mode: "no-cors",
      }).catch(useImageFallback);
      return;
    } catch {
      // Continue to image fallback.
    }
  }

  useImageFallback();
}
